
import { Issue, TimelineEvent } from './types';

// High-resolution, editorial-grade fashion and lifestyle imagery from Unsplash
const STOCK_IMAGES = {
  cover1: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?auto=format&fit=crop&q=80&w=1200', // Editorial Portrait
  cover2: 'https://images.unsplash.com/photo-1581067723713-35a133f6b707?auto=format&fit=crop&q=80&w=1200', // Luxury Interior
  cover3: 'https://images.unsplash.com/photo-1509319117193-57bab727e09d?auto=format&fit=crop&q=80&w=1200', // Fashion Minimal
  cover4: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=1200', // Modern Portrait
  cover5: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&q=80&w=1200', // Yellow Fashion
  cover6: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&q=80&w=1200', // Minimalist Accessory
  
  hero: 'https://images.unsplash.com/photo-1469334031218-e382a71b716b?auto=format&fit=crop&q=80&w=2000', // High-end Lifestyle Hero
  lifestyle: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?auto=format&fit=crop&q=80&w=1200',
  interior: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&q=80&w=1200',
  perfume: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&q=80&w=1200',
  food: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?auto=format&fit=crop&q=80&w=1200',
  resort: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&q=80&w=1200',
  spa: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&q=80&w=1200',
};

export const HERO_IMAGE = STOCK_IMAGES.hero;

export const SOCIAL_LINKS = {
  instagram: 'https://instagram.com/vanity_magazine',
  facebook: 'https://facebook.com/vanityaustria',
  linkedin: 'https://linkedin.com/company/vanity-magazine'
};

// Fix: Updated ISSUES to include all required fields of Issue interface
export const ISSUES: Issue[] = [
  {
    id: 'winter-2025',
    title: 'The Grand Winter Anthology',
    season: 'Winter',
    year: 2025,
    status: 'published',
    periodText: 'Winter 2025-2026',
    issueDate: '11.2025',
    isCurrent: true,
    isArchived: false,
    dateCreated: '2024-11-01T00:00:00Z',
    dateEdited: '2024-11-01T00:00:00Z',
    coverUrl: STOCK_IMAGES.cover1,
    summary: 'The Grand Winter Gala edition. Featuring the best of ballroom season, haute couture, and elite winter escapes in St. Moritz.',
    spreads: [STOCK_IMAGES.perfume, STOCK_IMAGES.interior, STOCK_IMAGES.resort]
  },
  {
    id: 'spring-2025',
    title: 'Spring Awakening',
    season: 'Spring',
    year: 2025,
    status: 'published',
    periodText: 'Spring 2025',
    issueDate: '03.2025',
    isCurrent: false,
    isArchived: false,
    dateCreated: '2024-12-01T00:00:00Z',
    dateEdited: '2024-12-01T00:00:00Z',
    coverUrl: STOCK_IMAGES.cover3,
    summary: 'Spring Awakening. A visual journey from the canals of Venice to the leading medical beauty clinics of Vienna.',
    spreads: [STOCK_IMAGES.spa, STOCK_IMAGES.food, STOCK_IMAGES.lifestyle]
  },
  {
    id: 'autumn-2024',
    title: 'The Golden Hour',
    season: 'Autumn',
    year: 2024,
    status: 'published',
    periodText: 'Autumn 2024',
    issueDate: '09.2024',
    isCurrent: false,
    isArchived: false,
    dateCreated: '2024-08-01T00:00:00Z',
    dateEdited: '2024-08-01T00:00:00Z',
    coverUrl: STOCK_IMAGES.cover4,
    summary: 'The Golden Hour. Exploring autumnal aesthetics and the future of regenerative health.',
    spreads: [STOCK_IMAGES.perfume, STOCK_IMAGES.food, STOCK_IMAGES.spa]
  },
  {
    id: 'summer-2023',
    title: 'The Summer Guide',
    season: 'Summer',
    year: 2023,
    status: 'published',
    periodText: 'Summer 2023',
    issueDate: '06.2023',
    isCurrent: false,
    isArchived: true,
    dateCreated: '2023-05-01T00:00:00Z',
    dateEdited: '2023-05-01T00:00:00Z',
    coverUrl: STOCK_IMAGES.cover5,
    summary: 'Special Summer Issue. The definitive guide to Austria\'s best cosmetic retreats and trending beauty treatments.',
    spreads: [STOCK_IMAGES.interior, STOCK_IMAGES.spa, STOCK_IMAGES.resort]
  },
  {
    id: 'winter-2024',
    title: 'Winter Solstice',
    season: 'Winter',
    year: 2024,
    status: 'published',
    periodText: 'Winter 2023-2024',
    issueDate: '11.2023',
    isCurrent: false,
    isArchived: true,
    dateCreated: '2023-10-01T00:00:00Z',
    dateEdited: '2023-10-01T00:00:00Z',
    coverUrl: STOCK_IMAGES.cover6,
    summary: 'Winter Solstice. Focus on skin health during the coldest months and Alpine luxury wellness.',
    spreads: [STOCK_IMAGES.interior, STOCK_IMAGES.resort, STOCK_IMAGES.lifestyle]
  }
];

// Added sortOrder to FEATURED_ARTICLES to resolve sorting property access errors in api.ts
export const FEATURED_ARTICLES = [
  {
    title: "The Alchemy of Scent",
    category: "Beauty",
    imageUrl: STOCK_IMAGES.perfume,
    description: "Discovering the niche perfume houses that are redefining modern luxury for the elite.",
    sortOrder: 100
  },
  {
    title: "Sanctuaries of Health",
    category: "Architecture",
    imageUrl: STOCK_IMAGES.interior,
    description: "Inside the most exclusive medical showrooms and recovery suites in Central Europe.",
    sortOrder: 101
  },
  {
    title: "Culinary Elegance",
    category: "Lifestyle",
    imageUrl: STOCK_IMAGES.food,
    description: "Where health-conscious nutrition meets the peak of fine dining art.",
    sortOrder: 102
  }
];

export const TIMELINE: TimelineEvent[] = [
  { year: 2025, milestone: 'The Grand Winter Anthology Launches', coverUrl: STOCK_IMAGES.cover1 },
  { year: 2024, milestone: '10th Anniversary celebration of the VANITY Print Journal', coverUrl: STOCK_IMAGES.resort },
  { year: 2023, milestone: 'Launch of the Exclusive Resort Distribution Hub', coverUrl: STOCK_IMAGES.cover3 },
  { year: 2020, milestone: 'Expanded DACH distribution to 800+ premium locations', coverUrl: STOCK_IMAGES.interior }
];
